import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { LogProvider } from './LogProvider.js';
export var LogFile =
/*#__PURE__*/
function (_LogProvider) {
  _inherits(LogFile, _LogProvider);

  function LogFile(content, limit) {
    var _this;

    _classCallCheck(this, LogFile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LogFile).call(this, limit)); // newlines that aren't proceeded by a '}' are either invalid or cary no meaning

    content = content.replace(/([^}])\s*([\n\r]+)/g, "$1");
    _this.content = content;
    _this.lines = _this.content.split('\n');
    return _this;
  }

  _createClass(LogFile, [{
    key: "loadEntries",
    value: function () {
      var _loadEntries = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(offset) {
        var count,
            start,
            end,
            entries,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                count = _args.length > 1 && _args[1] !== undefined ? _args[1] : 50;
                start = this.lines.length - offset;
                end = Math.max(start - count - 2, 0);
                entries = this.lines.slice(end, start).reverse().map(this.tryParseJSON);
                return _context.abrupt("return", {
                  data: entries
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadEntries(_x) {
        return _loadEntries.apply(this, arguments);
      }

      return loadEntries;
    }()
  }, {
    key: "tryParseJSON",
    value: function tryParseJSON(json) {
      try {
        return JSON.parse(json);
      } catch (e) {
        // fix unescaped message json
        var startPos = json.indexOf('"message":"') + '"message":"'.length;
        var endPos = json.lastIndexOf('","level":');
        var start = json.substr(0, startPos);
        var end = json.substr(endPos);
        var message = json.substr(startPos, endPos - startPos);
        var escapedMessage = message.replace(/([^\\]|^)["]/g, '$1\\"');
        json = start + escapedMessage + end;

        try {
          return JSON.parse(json);
        } catch (e) {
          console.log('Error while parsing log message:');
          console.log(json);
          console.error(e);
        }
      }
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogFile;
}(LogProvider);
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogFile, "LogFile", "/srv/http/owncloud/apps/logreader/js/Providers/LogFile.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();